<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="sienit">N</span>
          <input type="text" placeholder="Търсене" v-model="searchActivities" />
        </div>
        <span class="sienit modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content" v-if="!isComingFromReport">
        <div v-if="!activities.length" class="modal-content-template" @click="triggerFileInput()">
          <img
            class="modal-content-template-img desktop"
            src="../../assets/img/table_help.png"
            alt="Структура на таблицата"
          />
          <img
            class="modal-content-template-img mobile"
            src="../../assets/img/table_help_mobile.png"
            alt="Структура на таблицата"
          />
        </div>
        <div
          class="modal-content-item"
          v-for="(activity, index) in filteredActivities"
          :key="`activityModal-${index}-${activity.name}`"
          :title="activity.name"
        >
          <p>{{activity.name}}</p>
          <span class="sienit" @click="deleteActivity(index)" title>b</span>
        </div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="activities.length && !filteredActivities.length">
          Няма намерени резултати за '
          <strong>{{this.searchActivities}}</strong>'
        </p>
      </div>
      <div class="modal-content" v-else>
        <p
          v-if="!activities.length"
          class="modal-content-no-results text-align-center"
        >Все още няма добавени дейности</p>
        <div
          class="modal-content-item"
          v-for="(a, i) in filteredActivities"
          :key="`addActivities-${i}-${a._id}`"
          @click="saveSingle(a)"
          :title="a.name"
        >
          <p>
            {{ a.name }}
            <em>({{ a.unit }})</em>
          </p>
        </div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="activities.length && !filteredActivities.length">
          Няма намерени резултати за '
          <strong>{{this.searchActivities}}</strong>'
        </p>
      </div>
      <div class="modal-footer">
        <div class="btns-select" v-if="isComingFromReport">
          <button class="btn btn-select" @click="isEditInputModalOpened = true">
            <span class="sienit">L</span>
            Нова дейност
          </button>
        </div>
        <div v-else>
          <!-- EMPTY DIV FOR THE SPACE-AROUND RULE TO WORK -->
        </div>
        <div class="btns">
          <button class="btn btn-excel" @click="triggerFileInput()" v-if="!isComingFromReport">
            <span class="sienit">E</span>
            Нов файл
          </button>
          <input ref="uploadActivities" class="input-hide" type="file" @change="handleFile" />
          <!--  -->
          <button class="btn btn-new" @click="save()" v-if="!isComingFromReport">
            <span class="sienit">Y</span>
            Запази
          </button>
        </div>
      </div>
    </div>
    <EditInputModal v-if="isEditInputModalOpened" :isComingFromActivities="true"></EditInputModal>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import EditInputModal from './EditInputModal';
export default {
  components: {
    EditInputModal
  },
  props: [
    'incomingActivities',
    'isComingFromReport',
    'companyId',
    'projectId',
    'objectId'
  ],
  watch: {
    incomingActivities() {
      this.initActivities();
    }
  },
  data() {
    return {
      isEditInputModalOpened: false,
      activities: [],
      searchActivities: ''
    };
  },
  computed: {
    filteredActivities() {
      return this.filterActivities();
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.uploadActivities.click();
    },
    // EXCEL FILE TO JSON
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = e => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            for (let i = 0; i < keys.length; i++) {
              if (
                !(
                  keys[i].toLowerCase().includes('име') ||
                  keys[i].toLowerCase().includes('мерна единица') ||
                  keys[i].toLowerCase().includes('цена')
                )
              ) {
                this.$snotify.error(
                  'Таблицата трябва да има заглавен ред с Име / Мерна единица / Цена (евро)'
                );
                return;
              }
            }
            // ROW OBJECT
            for (let item in rows[row]) {
              // ROW DATA
              this.activities.push({
                name: rows[row][item][Object.keys(rows[row][item])[0]],
                unit: rows[row][item][Object.keys(rows[row][item])[1]],
                price: rows[row][item][Object.keys(rows[row][item])[2]]
              });
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error('Качените файлове трябва да бъдат .xls или .xlsx');
      }
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach(sheetName => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterActivities() {
      return this.activities.filter(a => {
        return a.name
          .toLowerCase()
          .includes(this.searchActivities.toLowerCase());
      });
    },
    // Handle added activity from EditInput
    handleAdd(newActivity) {
      // this.activities.unshift(newActivity);
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.companyId}`;
      this.$http
        .get(url)
        .then(response => {
          const company = response.data;
          // get index of selected project
          const indexOfProject = company.projects.findIndex(
            p => p._id === this.projectId
          );
          // get index of selected object
          const indexOfObject = company.projects[
            indexOfProject
          ].objects.findIndex(o => o._id === this.objectId);
          company.projects[indexOfProject].objects[
            indexOfObject
          ].activities.unshift(newActivity);

          // make the post request
          let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

          this.$http
            .put(url, company)
            .then(() => {
              this.$snotify.success('Успешно добавяне на нова дейност!');
              this.$parent.$emit('getActivitiesAgain');
            })
            .catch(error => {
              console.log(error);
              this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
            });
        })
        .catch(error => console.log(error));
    },
    deleteActivity(i) {
      this.activities.splice(i, 1);
    },
    getSelectedActivities() {
      return this.activities.filter(a => {
        return a.isSelected;
      });
    },
    close() {
      this.$parent.$emit('closeAddActivitiesModal');
    },
    saveSingle(a) {
      this.$parent.$emit('saveAddActivitiesModal', {
        name: a.name,
        unit: a.unit,
        price: a.price
      });
    },
    save() {
      this.$parent.$emit('saveAddActivitiesModal', this.activities);
    },
    initActivities() {
      this.activities = this.$cloneDeep(this.incomingActivities);

      this.activities.sort((x, y) => {
        return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      });
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    }
  },
  mounted() {
    this.initActivities();

    this.$on('saveMaterialActivityOrMechanization', this.handleAdd);
    this.$on('closeEditInputModal', this.closeEditInputModal);
  },
  destroyed() {
    this.$off('saveMaterialActivityOrMechanization');
    this.$off('closeEditInputModal');
  }
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
/* .modal-header {
  background: #17643a;
} */
.desktop {
  display: initial;
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
